var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.787 3.84934C15.503 3.56538 15.0425 3.56531 14.7585 3.84941L8.00015 10.6078L1.24152 3.84934C0.957555 3.56538 0.497023 3.56531 0.213023 3.84941C-0.0710078 4.13344 -0.0710078 4.59391 0.213023 4.87791L7.48593 12.1506C7.62231 12.287 7.80727 12.3636 8.00015 12.3636C8.19302 12.3636 8.37802 12.287 8.51437 12.1506L15.7869 4.87788C16.071 4.59388 16.071 4.13338 15.787 3.84934Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.7960c2b020b52f87552d60daa208db7f.svg";
export { ForwardRef as ReactComponent };